import React from 'react';
import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../constants/theme/theme-constants/colors';


const useStyles = makeStyles((theme) => ({
    grayBox: {
        background: tcsmColors.greySeven,
        padding: theme.spacing(1.25),
    },
}));


export const GrayBox = (props: React.PropsWithChildren<any>) => {
    const classes = useStyles();
    return (
        <>
            <div className={classes.grayBox}>
                {props.children}
            </div>
        </>
    );
};